/**
 * Who may see and answer the waiting room.
 *
 * Admitting someone into a meeting is a moderator action, and the two places
 * that offer it — the hover widget at the top left of the stage, and the
 * Waiting Room tab in the People panel — were showing it to everyone.
 *
 * The gate that was supposed to stop that read:
 *
 *     isHost: !props.localParticipant || props.localParticipant.role === 'host'
 *
 * which is wrong twice, in opposite directions.
 *
 * **Absence granted permission.** `!props.localParticipant` is TRUE before the
 * roster row for this client has resolved, and stays true for anyone it never
 * resolves for. A plain attendee in that state was handed the lobby feed and
 * the admit and reject buttons that go with it.
 *
 * **A co-host was refused.** The role vocabulary is `'host' | 'cohost' |
 * 'attendee'`, so `=== 'host'` excludes co-hosts — the other people who are
 * supposed to be able to let someone in.
 *
 * So the check is explicitly `=== true` rather than truthiness. The failure
 * this replaces was a missing value being read as permission, and
 * `Boolean(undefined)` is only accidentally different from
 * `Boolean('anything')`. A permission has to be granted, never merely
 * not-denied.
 */

/** The slice of `useRoomRoles` this needs, declared structurally for tests. */
export type LobbyRoles = {
  /** True for the host and for co-hosts — `useRoomRoles` computes it. */
  isModerator?: boolean | null
}

export function canManageLobby(roles: LobbyRoles | null | undefined): boolean {
  return roles?.isModerator === true
}
